var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-zitem text_item special_item",attrs:{"type":"text","id":_vm.detial.uuid}},[_c('p',[_vm._v(_vm._s(_vm.detial.textInput))])])}
var staticRenderFns = []

export { render, staticRenderFns }